import { render, staticRenderFns } from "./RentalsHeader.vue?vue&type=template&id=a32f6478&scoped=true"
import script from "./RentalsHeader.vue?vue&type=script&lang=js"
export * from "./RentalsHeader.vue?vue&type=script&lang=js"
import style0 from "./RentalsHeader.vue?vue&type=style&index=0&id=a32f6478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32f6478",
  null
  
)

export default component.exports